import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4f3fe9b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "checkout-address-viewer-double" }
const _hoisted_2 = {
  key: 0,
  class: "checkout-address-viewer-double__container"
}
const _hoisted_3 = { class: "checkout-address-viewer-double__header" }
const _hoisted_4 = {
  key: 0,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_5 = {
  key: 1,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_6 = {
  key: 2,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_7 = {
  key: 3,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_8 = {
  key: 4,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_9 = {
  key: 5,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_10 = {
  key: 6,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_11 = {
  key: 7,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_12 = {
  key: 8,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_13 = {
  key: 9,
  class: "checkout-address-viewer__text"
}
const _hoisted_14 = {
  key: 1,
  class: "checkout-address-viewer-double__container"
}
const _hoisted_15 = { class: "checkout-address-viewer-double__header" }
const _hoisted_16 = {
  key: 0,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_17 = {
  key: 1,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_18 = {
  key: 2,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_19 = {
  key: 3,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_20 = {
  key: 4,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_21 = {
  key: 5,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_22 = {
  key: 6,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_23 = {
  key: 7,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_24 = {
  key: 8,
  class: "checkout-address-viewer-double__text"
}
const _hoisted_25 = {
  key: 9,
  class: "checkout-address-viewer__text"
}

import dictionary from "@/i18n/dictionary.json";
import { PropType } from "vue";
import { ICustomerAddress } from "@/models/ICustomerAddress";


export default /*#__PURE__*/_defineComponent({
  __name: 'TressCheckoutAddressViewerDouble',
  props: {
  address: {
    type: Object as PropType<ICustomerAddress>,
    required: true,
  },
  address2: {
    type: Object as PropType<ICustomerAddress>,
    required: true,
  },
},
  setup(__props) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.address)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.invoiceAddress)), 1),
          (__props.address.fullName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(__props.address.fullName), 1))
            : _createCommentVNode("", true),
          (__props.address.attention)
            ? (_openBlock(), _createElementBlock("p", _hoisted_5, _toDisplayString(__props.address.attention), 1))
            : _createCommentVNode("", true),
          (__props.address.organizationNumber)
            ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(__props.address.organizationNumber), 1))
            : _createCommentVNode("", true),
          (__props.address.ean)
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(__props.address.ean), 1))
            : _createCommentVNode("", true),
          (__props.address.address)
            ? (_openBlock(), _createElementBlock("p", _hoisted_8, _toDisplayString(__props.address.address), 1))
            : _createCommentVNode("", true),
          (__props.address.address2)
            ? (_openBlock(), _createElementBlock("p", _hoisted_9, _toDisplayString(__props.address.address2), 1))
            : _createCommentVNode("", true),
          (__props.address.zipcode && __props.address.city)
            ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.address.zipcode) + ", " + _toDisplayString(__props.address.city), 1))
            : _createCommentVNode("", true),
          (__props.address.email)
            ? (_openBlock(), _createElementBlock("p", _hoisted_11, _toDisplayString(__props.address.email), 1))
            : _createCommentVNode("", true),
          (__props.address.phoneNumber)
            ? (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(__props.address.phoneNumber), 1))
            : _createCommentVNode("", true),
          (__props.address.reference)
            ? (_openBlock(), _createElementBlock("p", _hoisted_13, _toDisplayString(__props.address.reference), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (__props.address2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
          _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.$t(_unref(dictionary).checkout.deliveryAddress)), 1),
          (__props.address2.fullName)
            ? (_openBlock(), _createElementBlock("p", _hoisted_16, _toDisplayString(__props.address2.fullName), 1))
            : _createCommentVNode("", true),
          (__props.address2.attention)
            ? (_openBlock(), _createElementBlock("p", _hoisted_17, _toDisplayString(__props.address2.attention), 1))
            : _createCommentVNode("", true),
          (__props.address2.organizationNumber)
            ? (_openBlock(), _createElementBlock("p", _hoisted_18, _toDisplayString(__props.address2.organizationNumber), 1))
            : _createCommentVNode("", true),
          (__props.address2.ean)
            ? (_openBlock(), _createElementBlock("p", _hoisted_19, _toDisplayString(__props.address2.ean), 1))
            : _createCommentVNode("", true),
          (__props.address2.address)
            ? (_openBlock(), _createElementBlock("p", _hoisted_20, _toDisplayString(__props.address2.address), 1))
            : _createCommentVNode("", true),
          (__props.address2.address2)
            ? (_openBlock(), _createElementBlock("p", _hoisted_21, _toDisplayString(__props.address2.address2), 1))
            : _createCommentVNode("", true),
          (__props.address2.zipcode && __props.address2.city)
            ? (_openBlock(), _createElementBlock("p", _hoisted_22, _toDisplayString(__props.address2.zipcode) + ", " + _toDisplayString(__props.address2.city), 1))
            : _createCommentVNode("", true),
          (__props.address2.email)
            ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(__props.address2.email), 1))
            : _createCommentVNode("", true),
          (__props.address2.phoneNumber)
            ? (_openBlock(), _createElementBlock("p", _hoisted_24, _toDisplayString(__props.address2.phoneNumber), 1))
            : _createCommentVNode("", true),
          (__props.address2.reference)
            ? (_openBlock(), _createElementBlock("p", _hoisted_25, _toDisplayString(__props.address2.reference), 1))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})